import { Component, OnInit } from '@angular/core';
import { fromEvent, Subject, takeUntil } from 'rxjs';
import { HeaderComponent } from '../header/header.component';
import { SideNavComponent } from '../side-nav/side-nav.component';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-base-layout',
  standalone: true,
  imports: [CommonModule, RouterModule, HeaderComponent, SideNavComponent],
  templateUrl: './base-layout.component.html',
  styleUrls: ['./base-layout.component.css']
})
export class BaseLayoutComponent implements OnInit {
  sideNavPinned: boolean = false;
  sideNavHovered: boolean = false;

  get isSideNavOpen(): boolean {
    return this.sideNavPinned || this.sideNavHovered;
  }

  private unsubscriber: Subject<void> = new Subject<void>();
  constructor() { }

  ngOnInit(): void {
    history.pushState(null, '');
    fromEvent(window, 'popstate').pipe(takeUntil(this.unsubscriber)
    ).subscribe((_) => {
      history.pushState(null, '');
    });
  }
  setSideNavPinned(status: boolean) {
    this.sideNavPinned = status;
  }

  setSideNavHovered(status: boolean) {
    this.sideNavHovered = status;
  }

  ngOnDestroy(): void {
    this.unsubscriber.next();
    this.unsubscriber.complete();
  }
}
